import type { Call } from '@entities/call';
import type { BaseUsecase } from '@usecases/base-usecase';

export type DisconnectedTransferCallRequest = void;

export interface DisconnectedTransferCallRepository {
  fetchTransferCall(): Promise<Call>;
  removeTransferCalls(): Promise<void>;
}

export interface DisconnectedTransferCallEventPublisher {
  publish(call: Call): Promise<void>;
}

export interface DisconnectedTransferCallUsecase
  extends BaseUsecase<DisconnectedTransferCallRequest, void> {
  run(): Promise<void>;
}

export class DisconnectedTransferCall
  implements DisconnectedTransferCallUsecase
{
  constructor(
    private repository: DisconnectedTransferCallRepository,
    private publisher: DisconnectedTransferCallEventPublisher,
  ) {}

  async run(): Promise<void> {
    const call = await this.repository.fetchTransferCall();

    if (call) {
      await Promise.all([
        this.publisher.publish(call),
        this.repository.removeTransferCalls(),
      ]);
    }
  }
}
